export default __webpack_public_path__ + "static/media/kids-coloring-book-now-then-1-image.4607b5b8.jpg";